<template>
  <div v-if="product && product.isPair" class="product-pair-controls">
    <DefSwitch>
      <button
        :class="{ active: isPairSelected && product.price.quantity == 1 }"
        @click="handlerChangePair(1)"
      >
        {{ product?.type }}
      </button>
      <button
        :class="{ active: isPairSelected && product.price.quantity == 2 }"
        @click="handlerChangePair(2)"
      >
        {{ messages?.pair }}
      </button>
    </DefSwitch>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store';
import DefSwitch from '@components/Def/DefSwitch/DefSwitch.vue';

const { state, commit, dispatch } = useStore();

const product = computed(() => state.product.data.product);
const isPairSelected = computed(() => state.product.data.isPairSelected);
const messages = computed(() => state.product.data.messages);

const handlerChangePair = async (quantity: number) => {
  await dispatch('product/changeQuantity', { quantity });
  commit('product/selectPair', true);
};
</script>

<style lang="scss" scoped>
.product-pair-controls {
  margin-bottom: 16px;
  @include point-md {
    margin-bottom: 24px;
  }
}
</style>
